import React, {useEffect, useState} from "react";

import { useLocation, useParams } from "react-router-dom";
import BusinessDetails from "../components/BusinessDetails";
import BusinessSubscriptions from "../components/BusinessSubscriptions";
import BusinessInvoices from "../components/BusinessInvoices";

import { toast } from "react-hot-toast"; 

import * as tenantService from "../_services/tenantServices.js";

export default function BusinessDetailsPage() {
  const [loading, setLoading] = useState(false);
  const [tenant, setTenant] = useState(null);
  const location = useLocation();
  const plan = location.state?.plan || null;

  const params = new URLSearchParams(location.search);
  const tenantId = params.get("tenantId") || null;
  const target = params.get("target") || null;
  
  useEffect(() => {
    if(!tenantId) {
      setTenant(null);
      return;
    }

    const handleFetch = async () => {
      setLoading(false);
      try {
        const getTenant = await tenantService.getTenant(tenantId);
        setTenant(getTenant.data)
      } catch (error) {
        setTenant(null);
        toast.error(error.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    }

    handleFetch();
  },[]);
  
  const renderTarget = () => {
    switch (target) {
      case "subscriptions":
        return <BusinessSubscriptions tenant={tenant} />;

      case "subscribe":
        return <BusinessSubscriptions tenant={tenant} plan={plan} />;

      case "details":
        return <BusinessDetails tenant={tenant} />;

      case "invoices":
        return <BusinessInvoices tenant={tenant} />;

      default:
        return (
          <div className="container py-5">
            <div className="alert alert-warning">
              Unknown business action
            </div>
          </div>
        );
    }
  };

  return (
    <div className="container py-5">
      {!loading && (!tenantId || !tenant) && (
        <div className="alert alert-warning">
          Invalid Business
        </div>
      )}

      {loading && (
        <div className="container py-5">
          <div className="spinner"></div>
          <div className="alert alert-warning">
            Loading profile. Please wait...
          </div>
        </div>
      )}

      {!loading && tenant && target && renderTarget()}
    </div>
  );
}